import { render, staticRenderFns } from "./ProductDashboard.vue?vue&type=template&id=b7d8bbdc"
import script from "./ProductDashboard.vue?vue&type=script&lang=js"
export * from "./ProductDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports